import { navigate } from '@reach/router';
import { LoginMutation, LoginMutationVariables } from '../queries/__generated__/LoginMutation';
import { loginMutation } from '../queries/user';
import client from './client';
import redirect from './redirect';

// ==============================
// Auth Token Helpers
// ==============================

const AUTH_TOKEN = 'AuthToken';

export function getAuthToken() {
  const token = localStorage.getItem(AUTH_TOKEN);
  return token;
}

export function setAuthToken(token: string) {
  localStorage.setItem(AUTH_TOKEN, token);
  return token;
}

export function removeAuthToken() {
  localStorage.removeItem(AUTH_TOKEN);
}

// ==============================
// Login Helpers
// ==============================

// TODO: [JT] I feel like a lot of this should be handled in context/user.tsx

export async function login({ variables }: { variables: LoginMutationVariables }) {
  const loggedInResult = await client.mutate<LoginMutation, LoginMutationVariables>({
    mutation: loginMutation,
    variables
  });

  const token = loggedInResult!.data!.login.token;

  if (token) {
    await client.clearStore();
    setAuthToken(token);
    redirect('/');
  }
}

export async function loginAndWelcome({ variables }: { variables: any }) {
  await login({ variables });
  redirect('/welcome');
}

// ==============================
// Logout Helper
// ==============================

export function logout() {
  client.clearStore().then(() => {
    localStorage.clear();
    redirect('/login');
  });
}
